export enum FollowedGamesMode {
  Public = 'public',
  Private = 'private',
}
